import './index.css'

export default {
  name: 'Bpages',
  props: {
    small: { type: Boolean, default: () => false },
    page: { type: Number, default: () => 1 },
    size: { type: Number, default: () => 10 },
    pageSizes: { type: Array, default: () => [10, 20, 50, 100] },
    total: { type: Number, default: () => 0 },
    prevText: { type: String, default: () => '上页' },
    nextText: { type: String, default: () => '下页' },
    complete: { type: Boolean, default: () => true },
    background: { type: Boolean, default: () => true },
  },
  data() {
    return {
      pages: {
        page: this.page,
        size: this.size,
      },
    }
  },
  watch: {
    page(page) {
      this.pages.page = page;
    },
    size(size) {
      this.pages.size = size;
    },
  },
  methods: {
    currentChange(page) {
      this.pages.page = page;
      this.$emit('changePage', this.pages);
    },
    sizeChange(size) {
      this.pages.size = size;
      this.$emit('changeSize', this.pages);
    },
  },
  render() {
    return (
      <div class="b-pages">
        <el-pagination
          small={this.small}
          on-current-change={this.currentChange}
          on-size-change={this.sizeChange}
          current-page={this.pages.page}
          page-size={this.pages.size}
          page-sizes={this.pageSizes}
          layout={this.complete ? 'total, sizes, prev, pager, next, jumper' : 'prev, pager, next'}
          total={this.total}
          prev-text={this.prevText}
          next-text={this.nextText}
          background={this.background}
          {...{ props: this._props }}
        />
      </div>
    );
  }
}